import { VisibilityOffOutlined, VisibilityOutlined } from '@mui/icons-material';
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';
import { IconButton, Stack } from '@mui/material';

import CustomButton from '../../components/Button';
import ErrorMessage from '../../components/Errormessage';
import LoginModuleWrapper from '../../components/LoginModuleWrapper';
import { TextInput } from '../../components/TextInput';
import styles from './ResetPassword.module.scss';

interface ResetPasswordWrapperI {
  handleEmailModal: any;
  formData: any;
  handleInputChange: any;
  errorMessage: boolean;
  inputError: any;
  toggleIcon: any;
  togglePasswordIcon: any;
  passwordMatch: any;
  oneSpecialCharacter: any;
  oneDigit: any;
  oneUppercase: any;
  eightNumber: any;
  fourteenNumber: any;
  toggleConfirmPasswordIcon: any;
  oneLowercase: any;
  logoUrl: string;
  buttonDisabled?: boolean;
}

const doneIcon = {
  fontSize: '18px',
  paddingTop: '8px',
  marginRight: '4px',
};

const validationTopRow = {
  paddingBottom: '0.5rem',
  color: '#95969D',
};

const validationBottomRow = {
  color: '#95969D',
};

const ResetPasswordWrapper = ({
  handleEmailModal,
  formData,
  handleInputChange,
  errorMessage,
  inputError,
  toggleIcon,
  togglePasswordIcon,
  passwordMatch,
  oneSpecialCharacter,
  oneDigit,
  oneUppercase,
  eightNumber,
  fourteenNumber,
  toggleConfirmPasswordIcon,
  oneLowercase,
  logoUrl,
  buttonDisabled,
}: ResetPasswordWrapperI) => {
  return (
    <LoginModuleWrapper logoUrl={logoUrl}>
      <div className={styles.formWrapper}>
        <h1>Reset Password</h1>
        <h4>Please set your new password</h4>
        <form className={styles.customFormWrapper}>
          <div className={styles.passwordWrapper}>
            <TextInput
              type={toggleIcon.passwordIcon ? 'text' : 'password'}
              onChange={handleInputChange}
              name='password'
              label='New password'
              value={formData.password}
              placeholder='Enter new password'
              sx={{ marginBottom: '10px !important' }}
              postcontent={
                <IconButton onClick={() => togglePasswordIcon()}>
                  {toggleIcon.passwordIcon ? <VisibilityOffOutlined /> : <VisibilityOutlined />}
                </IconButton>
              }
            />
          </div>
          <div className={styles.pwdValidationSection}>
            <div className={styles.pwdValidationSection1}>
              <Stack style={validationTopRow} direction='row' ref={oneSpecialCharacter}>
                <DoneOutlinedIcon style={doneIcon} />
                <p>One special character</p>
              </Stack>

              <Stack style={validationBottomRow} direction='row' ref={oneDigit}>
                <DoneOutlinedIcon style={doneIcon} />
                <p>One number</p>
              </Stack>
            </div>
            <div className={styles.pwdValidationSection2}>
              <Stack style={validationTopRow} direction='row' ref={oneUppercase}>
                <DoneOutlinedIcon style={doneIcon} />
                <p>One uppercase</p>
              </Stack>

              <Stack style={validationBottomRow} direction='row' ref={eightNumber}>
                <DoneOutlinedIcon style={doneIcon} />
                <p>8 characters minimum</p>
              </Stack>
            </div>
            <div className={styles.pwdValidationSection2}>
              <Stack style={validationTopRow} direction='row' ref={fourteenNumber}>
                <DoneOutlinedIcon style={doneIcon} />
                <p>16 characters maximum</p>
              </Stack>
              <Stack style={validationTopRow} direction='row' ref={oneLowercase}>
                <DoneOutlinedIcon style={doneIcon} />
                <p>One lowercase</p>
              </Stack>
            </div>
          </div>
          <div className={styles.passwordWrapper}>
            <TextInput
              type={toggleIcon.confirmPasswordIcon ? 'text' : 'password'}
              onChange={handleInputChange}
              label='Re-enter password'
              name='confirmPassword'
              value={formData.confirmPassword}
              placeholder='Re-Enter new password'
              postcontent={
                <IconButton onClick={() => toggleConfirmPasswordIcon()}>
                  {toggleIcon.confirmPasswordIcon ? <VisibilityOffOutlined /> : <VisibilityOutlined />}
                </IconButton>
              }
            />
            {inputError.confirmPasswordError && (
              <p className={styles.inputFieldErrorMessage}>Enter a valid password *</p>
            )}
          </div>
          {(passwordMatch.passwordMatchError || passwordMatch.confirmPasswordMatchError) && (
            <ErrorMessage message="Passwords don't match" />
          )}
        </form>
        {errorMessage && <ErrorMessage message='All fields are required *' />}
        <CustomButton
          disabled={buttonDisabled}
          variant='contained'
          sx={{
            width: '100%',
            marginTop: '32px',
            height: '45px !important',
          }}
          form='reset-password-form'
          onClick={handleEmailModal}
        >
          Reset Password
        </CustomButton>
      </div>
    </LoginModuleWrapper>
  );
};

export default ResetPasswordWrapper;
